import i18n from "i18next";
import * as yup from "yup";

import { Shape } from "@/core/yup";
import { SignDocumentRequest } from "@/shared/domain";

export const formSchemaCustomerCardSign = yup.object<{}, Shape<SignDocumentRequest>>({
    approved: yup.boolean().oneOf([true], i18n.t("Validations.Required")),
    signedIn: yup.string().required(),
});
